import React, { Fragment,useEffect } from "react";
import "../../styles/common.css";
import "../../styles/invoice.css";
import { Outlet } from "react-router-dom";



const Layout = () => {
   
     useEffect(() => {
            document.title = "MedRecAps: Administrater"
         }, []);
    return (
        <Fragment>
          
           
                <section className="p-0 m-0 print-only">
                    <Outlet />
                </section>
            
        </Fragment>
    );
};

export default Layout;
